import React from 'react';
import { BRAND, PRODUCT_NAME, SUPPORT_EMAIL } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="border-t border-carbon-800 bg-black px-5 py-10 text-center md:px-12" data-id="element-224" data-mp="3r9aote3xlhyo">
      <p className="font-display text-xl font-extrabold uppercase tracking-[0.2em] text-accent-400" data-id="element-225" data-mp="3mgrc0jd2iqux">{BRAND}</p>
      <p className="mt-3 text-sm text-carbon-400" data-id="element-226" data-mp="3hhenzvagndqr">
        © 2026 {BRAND} · {PRODUCT_NAME} · Todos los derechos reservados.
      </p>
      <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-carbon-500" data-id="element-227" data-mp="3dervrt9vnqt1">
        {PRODUCT_NAME} es un recurso educativo y de consulta general. No reemplaza normativa vigente, documentación técnica
        específica, cálculo profesional, procedimientos de seguridad ni la intervención de arquitectos, ingenieros, técnicos,
        instaladores u otros profesionales habilitados cuando corresponda.
      </p>
      <nav aria-label="Enlaces legales" className="mt-5 text-sm text-carbon-400" data-id="element-228" data-mp="ws7gpb1vdsla">
        <span data-id="element-229" data-mp="wq4l8bhy7796">Términos y condiciones</span>
        <span className="mx-2 text-carbon-600" aria-hidden="true" data-id="element-230" data-mp="15qlsq69wrunr">·</span>
        <span data-id="element-231" data-mp="1apyfkr0s51qc">Política de privacidad</span>
        <span className="mx-2 text-carbon-600" aria-hidden="true" data-id="element-232" data-mp="1aqpzv5oxfd1b">·</span>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline-offset-4 transition-colors duration-150 hover:text-accent-400 hover:underline" data-id="element-233" data-mp="vt7aq28c6xtc">
          Contacto
        </a>
      </nav>
      <p className="mt-4 text-sm text-carbon-400" data-id="element-234" data-mp="1ohmroub13q7b">
        Soporte:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-accent-400 underline-offset-4 hover:underline" data-id="element-235" data-mp="1ojfw02y65yc5">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}